import { useStateValue } from 'state';

const useClientAccess = () => {
  const [{ dashboard }] = useStateValue();
  return hostingType => dashboard.client.hostingType === hostingType;
};
export default useClientAccess;
